import * as BomTypeGroupService from '../../../../services/bom-type-group.service';
import * as BomTypeService from '../../../../services/bom-type.services';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from '../../BomLibrary/store/BomLibrary.type';
import { ADD_BOM_TYPE, ADD_BOM_GROUP, GET_ALL_BOM, GET_FACTORY_PRODUCT_TYPES } from './BomType.type';

export const fetchBomTypeAction = (params) => async (dispatch) => {
  try {
    const res = await BomTypeService.fetchBomType(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: ADD_BOM_TYPE,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBoms = (params) => async (dispatch) => {
  try {
    const res = await BomTypeService.fetchAllBom(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_ALL_BOM,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addBomTypeAction = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomTypeService.addBomType(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_TYPE_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateBomTypeAction = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomTypeService.updateBomType(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_TYPE_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteBomTypeByIdAction = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomTypeService.deleteBomType(params);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_TYPE_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// bom type group action start
export const fetchBomTypeGroupAction = (params) => async (dispatch) => {
  try {
    const res = await BomTypeGroupService.getBomTypeGroup(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: ADD_BOM_GROUP,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addBomTypeGroupAction = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomTypeGroupService.addBomTypeGroup(data);
    if (res && res.code === 200 && res.data) {
      const msg = transactionMsg(`BOM_TYPE_GROUP_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchBomTypeByIdAction = (id) => async (dispatch) => {
  try {
    const res = await BomTypeService.fetchBomTypeById(id);
    if (res?.code === 200) {
      // console.log("res", res.data)
      await dispatch({ type: t.FETCH_BOM_LIBARARY, payload: res.data });
      return res;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTier_1_ProductAssociatesAction = () => async (dispatch) => {
  try {
    const res = await BomTypeService.getTier_1_ProductAssociates();
    if (res?.code === 200) {
      return res;
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getProductAssociatesAction = (params) => async (dispatch) => {
  try {
    const res = await BomTypeService.getProductAssociates(params);
    if (res?.code === 200) {
      await dispatch({
        type: GET_FACTORY_PRODUCT_TYPES,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchBomTypeGroupByIdAction = (id) => async (dispatch) => {
  try {
    const res = await BomTypeGroupService.fetchBomTypeGroupById(id);
    if (res?.code === 200) {
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateBomTypeGroupAction = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomTypeGroupService.updateBomTypeGroup(data);
    if (res && res.code === 200) {
      const msg = transactionMsg(`BOM_TYPE_GROUP_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteBomTypeGroupByIdAction = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await BomTypeGroupService.deleteBomTypeGroup(params);
    if (res && res.code === 200) {
      const msg = transactionMsg(`BOM_TYPE_GROUP_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) toasterMsg(res.message, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearHighlight = (data, transactionMsg) => async () => {
  try {
    const res = await BomTypeService.clearHighlight(data);
    if (res && res.code === 200) {
      toasterMsg(transactionMsg(res.data), 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateBomTypeSequence = (params, transactionMsg) => async () => {
  try {
    const res = await BomTypeService.updateBomTypeSequence(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`BOM_TYPE_VIEW.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(res.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
